module.exports = __webpack_public_path__ + "static/media/say.ac8e972a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/say.jpg
// module id = 328
// module chunks = 0